import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Tercera1997 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 89; i <= 116; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table0:[
              {'color':0,'shortname':'iberia', 'rivalName':'Iberia', 'pj':10, 'pg':6,'pe':1,'pp':3,'gf':12,'gc':9,'dif':3, 'pts':19},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':10, 'pg':6,'pe':2,'pp':2,'gf':21,'gc':11,'dif':10, 'pts':20},
	      {'color':0,'shortname':'malleco', 'rivalName':'Malleco', 'pj':10, 'pg':0,'pe':4,'pp':6,'gf':8,'gc':20,'dif':-12, 'pts':4},
	      {'color':0,'shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':10, 'pg':5,'pe':3,'pp':2,'gf':15,'gc':10,'dif':5, 'pts':18},
              {'color':0,'shortname':'uss', 'rivalName':'U. San Sebastián', 'pj':10, 'pg':1,'pe':1,'pp':8,'gf':7,'gc':17,'dif':-10, 'pts':4},
	      {'color':0,'shortname':'deplota', 'rivalName':'Dep. Lota', 'pj':10, 'pg':4,'pe':5,'pp':1,'gf':11,'gc':7,'dif':4, 'pts':17}],

	table1:[
              {'color':'#0047AB','shortname':'uss', 'rivalName':'U. San Sebastián', 'pj':10, 'pg':4,'pe':5,'pp':1,'gf':12,'gc':13,'dif':-1, 'pts':17},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':10, 'pg':4,'pe':4,'pp':2,'gf':15,'gc':11,'dif':4, 'pts':16},
              {'color':'#0047AB','shortname':'iberia', 'rivalName':'Iberia', 'pj':10, 'pg':3,'pe':6,'pp':1,'gf':16,'gc':16,'dif':0, 'pts':15},
              {'color':0,'shortname':'deplota', 'rivalName':'Dep. Lota', 'pj':10, 'pg':3,'pe':4,'pp':3,'gf':13,'gc':12,'dif':1, 'pts':13},
              {'color':'#ff3355','shortname':'malleco', 'rivalName':'Malleco', 'pj':10, 'pg':1,'pe':1,'pp':8,'gf':15,'gc':24,'dif':-9, 'pts':4},
              {'color':0,'shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':10, 'pg':4,'pe':2,'pp':4,'gf':19,'gc':14,'dif':5, 'pts':14}],

	table2:[
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':6, 'pg':2,'pe':1,'pp':3,'gf':11,'gc':11,'dif':0, 'pts':7},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':3,'pe':3,'pp':0,'gf':7,'gc':4,'dif':3, 'pts':12},
              {'color':0,'shortname':'barnechea', 'rivalName':'Barnechea', 'pj':6, 'pg':2,'pe':2,'pp':2,'gf':9,'gc':10,'dif':-1, 'pts':8},
              {'color':0,'shortname':'colchagua', 'rivalName':'Colchagua', 'pj':6, 'pg':1,'pe':2,'pp':3,'gf':8,'gc':10,'dif':-2, 'pts':5}],

    };
  }

  componentDidMount() {
	let newtable = this.sortTable(this.state.table1);
                this.setState({table1:newtable});

	let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});
	let newtable0 = this.sortTable(this.state.table0);
                this.setState({table0:newtable0});
        }



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){

  let subB = this.subText('#295e1e', 'Asciende a Primera B 1998');
  let subT = this.subText('#0047AB', 'Clasifica a Finales del Clausura');
  let subA = this.subText('#295e1e', 'Clasifica a Final del Apertura');
  let subP = this.subText('#295e1e', 'Clasifica a Liguilla de Ascenso');
  let subD = this.subText('#ff3355', 'Desciende a Cuarta División');

console.log(this.state.id_list)

  return(

	<div style={{textAlign: 'center' }}>
      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Apertura Grupo Sur </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table0} />}
	<div style={{ height: '10px' }}></div>
	{subA}
	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Clausura Grupo Sur</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
         {subP}
	 {subT}
	 {subD}
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Liguilla Ascenso</div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subB}
	 

	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Tercera 1997</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Tercera 1997</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Tercera 1997" />
     </div>


  )
}

}
export default Tercera1997;
